import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TELEMATIC_CHART_DATA]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TELEMATIC_CHART_DATA,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_CROPS]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_CROPS,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_CROPS_EXTENDED_INFO]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_CROPS_EXTENDED_INFO,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_EVENTS]: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_EVENTS,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_MOVEMENT_POINTS]: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_MOVEMENT_POINTS,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS]: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_EXTENDED_INFO]: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_EXTENDED_INFO,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_MOVED_MACHINES]: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_MOVED_MACHINES,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_REALTIME_DATA]: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_REALTIME_DATA,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_FIELD_WORKS]: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_FIELD_WORKS,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_LOGISTIC_WORKS]: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_LOGISTIC_WORKS,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_PREVIEW]: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_PREVIEW,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_TRACK]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_TRACK,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_RELATED_FIELD_WORKS]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_RELATED_FIELD_WORKS,
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_WIDE_TRACK]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_WIDE_TRACK,
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_WIDE_TRACK_CROSSED_CROPS]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_WIDE_TRACK_CROSSED_CROPS,
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_TRACK_POINTS]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_TRACK_POINTS,
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE_DATES]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE_DATES,
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE_DATE_DYNAMIC]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE_DATE_DYNAMIC,
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGES]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGES,
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE,
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGES_STATS]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGES_STATS,
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_DONE_WORK_GEOMETRIES]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MAPS].GET_DONE_WORK_GEOMETRIES,
	},
}
